import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useSEO } from '@/lib/useSEO';

export default function Transparency() {
  const { t } = useTranslation();
  useSEO({ title: 'Transparency', description: 'Live transparency dashboard of Universal Krishna Gaukul Mission — programmes, statutory registrations (PAN, CSR-1, NGO Darpan) and compliance information.' });
  const { data: s } = useQuery({ queryKey: ['tstats'], queryFn: async () => (await api.get('/transparency/stats')).data });

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24" data-testid="transparency-page">
      <h1 className="font-serif text-4xl md:text-6xl text-ukgm-blue font-semibold leading-tight">{t('transparency.title')}</h1>
      <p className="mt-4 max-w-2xl text-ukgm-slate text-lg">{t('transparency.subtitle')}</p>

      <div id="compliance" className="mt-10 scroll-mt-28 grid grid-cols-2 md:grid-cols-4 gap-4">
        <KPI label={t('transparency.active')} value={s?.total_projects ?? ''} testid="kpi-active" />
        <KPI label="PAN" value="AABTU5738J" testid="kpi-pan" />
        <KPI label="CSR-1" value="CSR00106731" testid="kpi-csr" />
        <KPI label="NGO Darpan" value="MH/2025/0872011" testid="kpi-darpan" />
      </div>

      <div className="mt-10 bg-ukgm-blue text-white rounded-2xl p-8">
        <div className="text-xs tracking-widest uppercase text-ukgm-gold font-bold">Compliance Statement</div>
        <p className="mt-3 text-white/85 leading-relaxed max-w-3xl">
          Universal Krishna Gaukul Mission is a Public Charitable Trust registered under the Bombay Public Trusts Act, 1950.
          Every rupee received is deployed as per the objectives set out in the Trust Deed. Audited financial statements will be published on this Transparency page as they are formally released.
        </p>
        <div className="mt-6 grid sm:grid-cols-2 gap-3 text-sm">
          <div className="bg-white/10 border border-ukgm-gold/40 rounded-2xl p-4">
            <div className="text-ukgm-gold text-xs tracking-widest uppercase font-bold">Bank</div>
            <div className="mt-1 font-semibold">HDFC Bank</div>
          </div>
          <div className="bg-white/10 border border-ukgm-gold/40 rounded-2xl p-4">
            <div className="text-ukgm-gold text-xs tracking-widest uppercase font-bold">Account Number</div>
            <div className="mt-1 font-semibold">50200117192679</div>
          </div>
          <div className="sm:col-span-2 bg-white/10 border border-ukgm-gold/40 rounded-2xl p-4">
            <div className="text-ukgm-gold text-xs tracking-widest uppercase font-bold">Account Title</div>
            <div className="mt-1 font-semibold">UNIVERSAL KRISHNA GAUKUL MISSION</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function KPI({ label, value, testid }) {
  return (
    <div className="bg-white rounded-2xl border border-ukgm-gold/25 p-5 card-lift" data-testid={testid}>
      <div className="text-xs uppercase tracking-widest text-ukgm-slate font-bold">{label}</div>
      <div className="mt-2 font-serif text-2xl text-ukgm-blue font-semibold break-all">{value}</div>
    </div>
  );
}
